import { baseSplitApi } from "../baseApi";

const collabPropositionPath = "/cip_client/generate_link_for_collab"
const collabPropositionDataPath = "/collaboration_proposition"


export const pitchDeckApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    generateCollabPropositionLink: build.mutation({
      query: ({ id }) => {
        return {
          url: `${collabPropositionPath}/${id}`,
          method: "GET"
        }
      }
    }),
    getCollaborationData: build.query({
      query: (data) => {
        return {
          url: `${collabPropositionDataPath}`,
          method: "GET",
        }
      },
      transformResponse: (response) => response.data[0]
    }),
    getClientCollaborationData: build.mutation({
      query: ({ _id }) => {
        return {
          url: `${collabPropositionDataPath}/get_client_data/${_id}`,
          method: "POST",
        }
      },
      // transformResponse: (response) => response.data[0]
    }),
    getAllClientCollaborationData: build.query({
      query: () => {
        return {
          url: `${collabPropositionDataPath}/get_all_client_collaborations`,
          method: "GET",
        }
      }
    }),
    saveCollaborationData: build.mutation({
      query: (data) => {
        return {
          url: `${collabPropositionDataPath}/save_data`,
          method: "POST",
          body: data
        }
      }
    }),
    saveClientCollaborationData: build.mutation({
      query: (data) => {
        return {
          url: `${collabPropositionDataPath}/save_client_data`,
          method: "POST",
          body: data
        }
      }
    })
  })
})


export const { useGenerateCollabPropositionLinkMutation, useGetCollaborationDataQuery, useGetAllClientCollaborationDataQuery, useGetClientCollaborationDataMutation, useSaveCollaborationDataMutation, useSaveClientCollaborationDataMutation } = pitchDeckApi